import { Table } from '@wyz/ui';
import { PropsWithChildren } from 'react';
import clsx from 'clsx';

function QuoteTable({
  showBuyingInfo,
  children,
}: PropsWithChildren<{ showBuyingInfo: boolean }>) {
  return (
    <Table
      className={clsx('product-table quote-table', {
        'customer-view': !showBuyingInfo,
      })}
      bordered
      style={{ tableLayout: 'fixed' }}
    >
      {children}
    </Table>
  );
}

export default QuoteTable;
